const { getElement, isInViewport } = window.BAO.Utils;

class ProductDeliveryInfo extends window.BAO.CustomElement() {
  connectedCallback() {
    super.connectedCallback();
  }

  setupListeners() {
    super.setupListeners();
    this.updateThresholdText = this.updateThresholdText.bind(this);
    window.BAO.eventBus.addEventListener(
      window.BAO.EVENTS.PUSH_CART.CHANGED,
      this.updateThresholdText
    );

    this.listeners.add(this, "click", this.handleClick.bind(this));
  }

  updateThresholdText(e) {
    const { state } = e.detail;

    if (!state || !state?.sections) return;
    if (!("push-cart-footer" in state.sections)) return;

    const cartTotal = this.getCartTotal(state.sections["push-cart-footer"]);

    if (cartTotal >= this.threshold && this.els?.header.element) {
      this.els.header.element.innerHTML = this.cartThresholdMetText;
    } else if (this.productPrice >= this.threshold) {
      this.els.header.element.innerHTML = this.productThresholdMetText;
    } else {
      this.els.header.element.innerHTML = this.defaultText;
    }
  }

  handleClick() {
    const shippingAccordion = getElement(".prd-Detail_Accordion-shipping");

    if (!shippingAccordion) return;

    if (!shippingAccordion.detailsEl.open) {
      shippingAccordion.open()
    }
    
    if (!isInViewport(shippingAccordion)) {
      shippingAccordion.scrollIntoView({
        behavior: "smooth",
        block: "start",
      });
    }
  }

  get threshold() {
    return this?.dataset.deliveryThreshold;
  }

  get productPrice() {
    return this?.dataset.productPrice;
  }

  get cartThresholdMetText() {
    return this?.dataset.cartThresholdMet;
  }

  get productThresholdMetText() {
    return this?.dataset.productThresholdMet;
  }

  get defaultText() {
    return this?.dataset.defaultText;
  }

  getCartTotal(html) {
    const DOM = window.BAO.sectionRenderer.convertToDOM(html);

    return DOM.querySelector(".psh-CartFooter_Value")?.dataset.cartValue;
  }
}

if (!customElements.get("product-delivery-info")) {
  customElements.define("product-delivery-info", ProductDeliveryInfo);
}
